import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getExperienceLevels,
  getJobTypes,
  getJobs,
  getSalaryType,
  getStateRegions,
  getTracks,
  updateJobsParams,
  updateLoadJobKey,
} from "../../../redux/actions/job_action";
import AppBar from "../../shared/SharedNavbar/SharedNavbar";
import SharedSnackbar from "../../shared/SharedSnackbar/SharedSnackbar";
import FilterWrapper from "../FilterWrapper/FilterWrapper";
import Pagination from "../Pagination/Pagination";
import SingleJobWrapper from "../SingleJobWrapper/SingleJobWrapper";
import { Wrapper } from "./styles";

function JobListWrapper() {
  const dispatch = useDispatch();
  const jobParams = useSelector((state) => state.jobs?.jobsParams);
  const jobs = useSelector((state) => state.jobs?.jobs);
  const pagination = useSelector((state) => state.jobs?.pagination);

  useEffect(() => {
    dispatch(getTracks());
    dispatch(getExperienceLevels());
    dispatch(getStateRegions());
    dispatch(getJobTypes());
    dispatch(getSalaryType());

    const loadJobKey = moment().format("dd/mm/yyyy hh:mm:ss");

    const clearParams = {
      expectedSalary: 0,
      type: null,
      expectedSalaryFull: "",
      expectedSalaryFullBm: "",
      keyword: jobParams?.keyword ?? "*",
      keywordDisplay: jobParams?.keywordDisplay ?? "",
      trackIds: [],
      trackIdsFull: [],
      stateRegions: [],
      stateRegionsFull: [],
      jobTypeIds: [],
      jobTypeIdsFull: [],
      experienceIds: [],
      experienceIdsFull: [],
    };

    dispatch(updateJobsParams(clearParams));
    // dispatch(updateFilterApplied(false));

    dispatch(updateLoadJobKey(loadJobKey)).then(() => {
      const params = {
        ...clearParams,
        loadJobKey: loadJobKey,
      };
      dispatch(getJobs(params, pagination));
    });

    return () => {
      dispatch(
        updateJobsParams({
          expectedSalary: 0,
          type: "",
          expectedSalaryFull: "",
          expectedSalaryFullBm: "",
          keyword: "*",
          keywordDisplay: "",
          trackIds: [],
          trackIdsFull: [],
          stateRegions: [],
          stateRegionsFull: [],
          jobTypeIds: [],
          jobTypeIdsFull: [],
          experienceIds: [],
          experienceIdsFull: [],
        })
      );
    };
  }, []);

  return (
    <Wrapper>
      <AppBar />
      <FilterWrapper />
      <SingleJobWrapper />
      {jobs.length > 0 && <Pagination />}
      <SharedSnackbar />
    </Wrapper>
  );
}

export default JobListWrapper;
